import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'presentation/redux/reducers/rootReducer'

export const store = configureStore({
  reducer: rootReducer,
})
